var React = require('react');

function Printer (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M20.625 18.567h-2.808v3.427c0 .38-.308.689-.687.689H4.755c-.38 0-.63-.303-.63-.683v-3.433h-2.75A1.378 1.378 0 0 1 0 17.191V7.558c0-.76.617-1.377 1.375-1.377h2.75V1.372c0-.38.308-.689.688-.689h12.375c.379 0 .687.308.687.69V6.18h2.75c.758 0 1.375.618 1.375 1.377v9.633c0 .758-.617 1.376-1.375 1.376zm-15.183-.695l.002.007-.002.007v3.42l11.058.006v-3.16a.684.684 0 0 1 0-.547V13.75l-11.058-.013v4.135zM16.5 2.06h-11v4.12h11V2.06zm4.125 5.498h-3.4c-.013 0-.024.007-.038.007H4.813c-.013 0-.024-.007-.037-.007h-3.4v9.633h2.75v-4.128c0-.381.25-.702.63-.702H17.13c.38 0 .687.307.687.688v4.142h2.808V7.558zM16.5 9.63c0-.381.308-.688.688-.688h.687a.687.687 0 1 1 0 1.375h-.688a.687.687 0 0 1-.687-.687z"}));
}

Printer.displayName = "Printer";

Printer.defaultProps = {"viewBox":"0 0 22 23"};

module.exports = Printer;

Printer.default = Printer;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/printer.svg
// module id = 1283
// module chunks = 0